// extracted by mini-css-extract-plugin
module.exports = {"pageBanners":"style_pageBanners__2omlB","warning":"style_warning__1hoFr"};